export const insertElement = <T>(index: number, array: T[], element: T): T[] => {
  return [...array.slice(0, index), element, ...array.slice(index)];
};
